export default {
    organisationBaseData: 'Daten',
    organisationUsers: 'Nutzer',
    organisationCategories: 'Kategorien',
    organisationStemSheet: 'Stammblatt',
    organisationProtectionConcept: 'Schutzkonzept',
    organisationAssociationSettings: 'Verbandseinstellungen',
    organisationActivities: 'Historie',
}
